/**
 * DEFCAT P5 slice 3 — collection narrowing for the drawer pickers.
 *
 * A user COLLECTION is an ordered subset of catalogue entries (TYPE and/or
 * LOCATION, any node). When a collection is active, the drawer shows its
 * narrowed set by default with a toggle back to the full catalogue
 * (concept §2c / workflow 2c).
 *
 * A collection may narrow only one axis (e.g. a "favourite defect types"
 * collection lists only type entries): in that case the OTHER axis is left
 * un-narrowed. So we partition the collection's entry ids per axis and only
 * apply a filter to an axis when the collection actually contributes ids to it.
 *
 * Pure (no React) so the partitioning is unit-tested in isolation.
 */
export interface CollectionAxisIds {
  /** Type entry ids in the collection (empty ⇒ don't narrow the type axis). */
  typeIds: Set<string>;
  /** Location entry ids in the collection (empty ⇒ don't narrow locations). */
  locationIds: Set<string>;
}

export function partitionCollectionEntryIds(
  collectionEntryIds: readonly string[] | null | undefined,
  typeEntryIds: ReadonlySet<string>,
  locationEntryIds: ReadonlySet<string>,
): CollectionAxisIds {
  const typeIds = new Set<string>();
  const locationIds = new Set<string>();
  for (const id of collectionEntryIds ?? []) {
    if (typeEntryIds.has(id)) typeIds.add(id);
    else if (locationEntryIds.has(id)) locationIds.add(id);
  }
  return { typeIds, locationIds };
}
